import { render, staticRenderFns } from "./RichTextSuperscript.vue?vue&type=template&id=6d4b2a2e&scoped=true&"
import script from "./RichTextSuperscript.vue?vue&type=script&lang=js&"
export * from "./RichTextSuperscript.vue?vue&type=script&lang=js&"
import style0 from "./RichTextSuperscript.vue?vue&type=style&index=0&id=6d4b2a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4b2a2e",
  null
  
)

export default component.exports